export default [
  {
    path: "/arrivals",
    name: "arrivals",
    component: () => import("./pages/index.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Поступления",
      permissions: ["arrival:index"],
    },
  },
];
